import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input, Label } from "../../../components/base";
import { FieldDescription } from "../FieldDescription";
export const ShortTextField = ({ field, value, disabled, error, onChange, }) => {
    return (_jsxs("div", { className: "space-y-1", children: [_jsxs(Label, { className: "text-xs", children: [field.question, " ", field.required && _jsx("span", { className: "text-red-500", children: "*" })] }), _jsx(FieldDescription, { ...field }), _jsx(Input, { value: value ?? "", onChange: (e) => onChange?.(e.target.value), placeholder: field.placeholder, disabled: disabled, className: error ? "border-red-500 focus-visible:ring-red-500" : undefined }), error && _jsx("p", { className: "text-xs text-red-500", children: error })] }));
};
export const validateShortTextField = (field, value, t) => {
    if (!field.required)
        return undefined;
    const str = value === undefined || value === null ? "" : String(value);
    if (str.trim() === "") {
        return t("form.validation.required");
    }
    return undefined;
};
//# sourceMappingURL=ShortTextField.js.map